<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>Buefy Firebase Auth</strong> by
        <a href="https://www.berviantoleo.my.id">Bervianto Leo Pratama</a>. The
        source code is licensed
        <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The
        website content is licensed
        <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/"
          >CC BY NC SA 4.0</a
        >.
      </p>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MyFooter",
});
</script>
